var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2496 14.9688H25.1575C25.0043 14.9688 24.859 15.0391 24.7653 15.1594L18.3231 23.3203L15.234 19.4062C15.1873 19.3469 15.1277 19.2989 15.0598 19.2659C14.9919 19.2329 14.9174 19.2157 14.8418 19.2156H13.7496C13.645 19.2156 13.5871 19.3359 13.6512 19.4172L17.9309 24.8391C18.1309 25.0922 18.5153 25.0922 18.7168 24.8391L26.3481 15.1688C26.4121 15.0891 26.3543 14.9688 26.2496 14.9688Z",
    fill: "#C9DB89"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.5,
    y: 39.5,
    width: 39,
    height: 39,
    rx: 19.5,
    transform: "rotate(180 39.5 39.5)",
    stroke: "#C9DB89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.ce4fced3f8a26aa3444c4e3ccbd49782.svg";
export { ForwardRef as ReactComponent };